<label
  class="radio-card"
  [class.radio-card--checked]="checked()"
  [class.radio-card--disabled]="disabled()"
>
  @if (disabled() && badge()) {
    <span class="radio-card__badge">{{ badge() }}</span>
  }
  <span class="radio-card__top">
    <input
      class="radio-card__input"
      type="radio"
      [name]="name()"
      [value]="value()"
      [checked]="checked()"
      [disabled]="disabled()"
      (change)="handleChange()"
    />
    <span class="radio-card__title">{{ title() }}</span>
  </span>
  <span class="radio-card__description">{{ description() }}</span>
</label>
